import { TemplateKey } from "PFApp/constants/templates";
import { useTranslation } from "react-i18next";

import css from "../close_confirm_modal.module.scss";

type CloseConfirmModalHeaderProps = {
  isVisible: boolean;
  templateKey: TemplateKey | undefined;
  openVacancies: number;
};

export const CloseConfirmModalHeader = ({
  isVisible,
  templateKey,
  openVacancies
}: CloseConfirmModalHeaderProps) => {
  const { t } = useTranslation("activities");

  if (!isVisible) {
    return null;
  }

  return (
    <div className={css.header}>
      {t(`closeActivity.with_vacancies.title.${templateKey}` as unknown as TemplateStringsArray, {
        count: openVacancies
      })}
    </div>
  );
};
